export type RoleTag = { type: typeof RoleTagType; id: string }
export const RoleTagType = 'Role'
